module.exports = __webpack_public_path__ + "99c28dec08e2010466873ae0d66e10d7.png";


//////////////////
// WEBPACK FOOTER
// ./images/slide4.png
// module id = 674
// module chunks = 0